<template lang="html">
  <section class="atlas">
    <router-view />
  </section>
</template>

<script>
import RemoteLink from '@/components/RemoteLink';
import FormattedTable from '@/components/FormattedTable';
import {
  atlasAppShortName,
  atlasAppName,
  atlasAppDescription,
  clientOrigin,
} from '@/constants';
import { metaTitles, metaDescriptions, metaImages } from '@/utils/meta';

export default {
  name: 'About',

  metaInfo() {
    return {
      titleTemplate: `%s | ${atlasAppShortName}`,
      meta: [
        ...metaTitles(atlasAppName),
        ...metaDescriptions(atlasAppDescription),
        ...metaImages(
          {
            url: `${clientOrigin}/img/logo-atlas.png`,
            metadata: {
              width: 512,
              height: 512,
              mimeType: 'image/png',
            },
          },
          `${atlasAppName} logo`
        ),
      ],
    };
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/mixins/app-width';

.atlas {
  @include app-width;

  display: flex;
}
</style>
